import React, { useState } from 'react';
import styles from './PasswordInput.module.css';

const PasswordInput = ({ value, onChange, placeholder, id, required, autoComplete }) => {
    const [show, setShow] = useState(false);
    return (
        <div className={styles.inputWrapper}>
            <input
                id={id}
                className={styles.input}
                type={show ? 'text' : 'password'}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoComplete={autoComplete}
                required={required}
            />
            <button
                type="button"
                className={styles.toggleButton}
                onClick={() => setShow(v => !v)}
            >
                {show ? 'Hide' : 'Show'}
            </button>
        </div>
    );
};

export default PasswordInput;
